import React from "react";
import { connect } from "react-redux";
import Button from "components/Button";
import { ToastContainer, toast } from "react-toastify";
import {
  StyledForm,
  FormGroup,
  UpgradeText,
  BrandingFormSection,
  UpgradeButtonLinkContainer,
  UpgradeButtonLink,
} from "./styledComponents";
import { BrandFormField, PhotoFilterPreview } from "./components";
import DevicePreview, {
  GalleryPreview,
} from "../../../components/DevicePreview";
import { Field } from "redux-form";
import { colors } from "globalStyles";
import { isObject } from "utils/helpers";
import Divider from "components/Divider";
const notify = () => toast("Changes Saved!");

const getFilePath = (file) => {
  if (isObject(file)) {
    const fileObj = file[0] || file;
    try {
      return fileObj ? window.URL.createObjectURL(fileObj) : "";
    } catch (err) {
      return fileObj ? fileObj.name : "";
    }
  }

  return file;
};

const validateImage = (value, width, height) => {
  return new Promise((resolve, reject) => {
    if (!value) resolve();
    const img = new Image();
    const _URL = window.URL || window.webkitURL;
    var objectUrl = _URL.createObjectURL(value.target.files[0]);
    img.onload = function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (width === img.naturalWidth && height === img.naturalHeight) resolve();
      else reject();
    };
    img.src = objectUrl;
  });
};

const formOptions = [
  {
    fields: (userType) => [
      {
        name: "big_logo_image_url",
        header: "App Logo",
        description: "Upload a .PNG file, exactly 1300px wide by 800px tall",
        label: "App Logo File",
        type: "file",
        enableRemoveIcon: true,
        placeholder: "upload a .PNG file, exactly 1300px wide by 800px tall",
        validateFnc: (value) => validateImage(value, 1300, 800),
        validateMsg:
          "The image does not match the required resolution (1300px wide by 800px tall)",
      },
      {
        name: "app_background_color",
        header: "App Background",
        description: "Pick a color, any color",
        disable_description:
          "Remove uploaded image to switch to basic color background.",
        label: "App Background",
        type: "color",
        colorPreviewOnLeft: true,
        enableRemoveIcon: true,
        placeholder: "enter hex number or pick a color form drop-down",
        disabled: (brandForm) => (brandForm["overlay_image"] ? true : false),
        subFields: [
          userType === "lite"
            ? {
                type: "upgrade",
                description: "Upgrade for full-screen Image backgrounds",
              }
            : {
                name: "overlay_image",
                label: "App Background File",
                description:
                  "or upload a .PNG file, exactly 1536px wide by 2048px tall",
                placeholder:
                  "upload a .PNG file, exactly 1536px wide by 2048px tall",
                type: "file",
                enableRemoveIcon: true,
                validateFnc: (value) => validateImage(value, 1536, 2048),
                validateMsg:
                  "The image does not match the required resolution (1536px wide by 2048px tall)",
              },
        ],
      },
    ],
    previewComponent: (brandForm) => {
      return (
        <DevicePreview
          type="pro"
          logoImage={getFilePath(brandForm["big_logo_image_url"])}
          overlayImage={getFilePath(brandForm["overlay_image"])}
          backgroundColor={brandForm["app_background_color"]}
        />
      );
    },
  },
  {
    fields: (userType) => [
      {
        name: "photo_filters",
        header: "Photo Filters",
        description: "Upload .PNG files, exactly 960px wide by 1280px tall.",
        label: "Photo Filter Files",
        type: "file",
        placeholder: "upload .PNG files, exactly 960px wide by 1280px tall",
        isMultiSelect: true,
        validateFnc: (value) => validateImage(value, 960, 1280),
        validateMsg:
          "The image does not match the required resolution (960px wide by 1280px tall)",
      },
      userType === "lite"
        ? {
            type: "upgrade",
            description:
              "Upgrade to give users multiple filters to choose from",
          }
        : "",
    ],
    previewComponent: (brandForm) => {
      var photos = brandForm["photo_filters"];
      // photos[0].selected = true;
      if (photos && Array.isArray(photos)) {
        if (photos.length > 0 && photos.filter((x) => x && x.selected).length === 0) {
          photos[0].selected = true;
        }
          photos = photos.filter((x) => x && x.selected);

        
        photos = photos
          ? photos.map((item) =>
              typeof item.file === "string" ? item.file : getFilePath(item.file)
            )
          : null;
      }

      return <PhotoFilterPreview photoOptions="4pose" photoFilters={photos} />;
    },
  },
  {
    fields: (userType) => [
      {
        name: "gallery_banner",
        header: "Gallery Logo",
        description:
          "Upload a .PNG file, exactly 1300px wide by 800px tall. Your App Logo is the default.",
        label: "Gallery Logo File",
        placeholder: "upload .PNG files, exactly 1300px wide by 800px tall",
        validateFnc: (value) => validateImage(value, 1300, 800),
        validateMsg:
          "The image does not match the required resolution (1300px wide by 800px tall)",
        type: "file",
      },
      userType === "lite"
        ? {
            type: "upgrade",
            description: "Upgrade to add Copy and CTA button",
          }
        : {
            name: "header",
            header: "Gallery Copy",
            description:
              "Enter a headline and subheadline copy to add to your gallery.",
            placeholder: "Movebooth is the Photo Booth that Moves YOU",
            label: "gallery headline",
            type: "text",
            multiline: 5,
            subFields: [
              {
                name: "sub_header",
                label: "gallery sub-headline",
                type: "text",
                multiline: 5,
              },
              !["pro", "enterprise_admin", "super_admin"].includes(userType)
                ? {
                    name: "brand_cta_button_nedd_upgrade",
                    type: "upgrade",
                    description: "Upgrade to add CTA button",
                  }
                : {
                    name: "gallery_cta_text",
                    label: "CTA Button Label",
                    type: "text",
                  },
              ["lite", "plus"].includes(userType)
                ? null
                : {
                    name: "gallery_cta_link",
                    label: "CTA Button Url",
                    type: "text",
                  },
            ],
          },
      {
        name: "gallery_color",
        header: "Gallery Background",
        description: "Pick a color, any color.",
        label: "Gallery Background",
        type: "color",
        placeholder: "enter hex number or pick a color from drop-down",
        colorPreviewOnLeft: true,
      },
    ],
    previewComponent: (brandForm) => (
      <GalleryPreview
        logoImage={
          getFilePath(brandForm["gallery_banner"]) ||
          getFilePath(brandForm["big_logo_image_url"])
        }
        backgroundColor={brandForm["gallery_color"] || colors.MENU}
        headline={brandForm["header"]}
        subHeadline={brandForm["sub_header"]}
        buttonText={brandForm["gallery_cta_text"]}
      />
    ),
    marginBottom: 48,
  },
]

const BrandingForm = ({
  nextTab,
  openColorPickerModal,
  brandForm,
  edit,
  submitting,
  handleSubmit,
  permissionRole,
}) => {
  return (
    <StyledForm onSubmit={handleSubmit}>
      <ToastContainer />
      {formOptions.map((options, idx) => {
        return (
          <div key={idx}>
            <FormGroup className="branding-form-group">
              <BrandingFormSection>
                <div className="left-side">
                  {options.fields(permissionRole).map((fieldProps, idx) => {
                    return typeof fieldProps.name !== "undefined" ? (
                      <div key={idx}>
                        <Field
                          key={fieldProps.name}
                          component={BrandFormField}
                          openColorPickerModal={openColorPickerModal}
                          brandForm={brandForm}
                          value={brandForm.name}
                          name={fieldProps.name}
                          permissionRole={permissionRole}
                          {...fieldProps}
                          enableRemoveIcon={
                            fieldProps.name === "gallery_banner"
                              ? brandForm["gallery_banner"]
                              : fieldProps.enableRemoveIcon
                          }
                        />
                        {fieldProps.name === "photo_filters" &&
                          permissionRole === "lite" && (
                            <UpgradeButtonLinkContainer>
                              <UpgradeButtonLink
                                href="mailto:sales@movebooth.com?&subject=Movebooth%20Account%20Upgrade%20Request&body=I'd Like to upgrade to give users multiple filters to choose
                                from!"
                                target="_blank"
                                rel="noreferrer noopener"
                              >
                                Upgrade to give users multiple filters to choose
                                from
                              </UpgradeButtonLink>
                            </UpgradeButtonLinkContainer>
                          )}
                        {fieldProps.name === "gallery_banner" &&
                          permissionRole === "lite" && (
                            <UpgradeButtonLinkContainer>
                              <UpgradeButtonLink
                                href="mailto:sales@movebooth.com?&subject=Movebooth%20Account%20Upgrade%20Request&body=I'd Like to upgrade to add Copy and CTA Button!"
                                target="_blank"
                                rel="noreferrer noopener"
                              >
                                Upgrade to add Copy and CTA Button
                              </UpgradeButtonLink>
                            </UpgradeButtonLinkContainer>
                          )}
                      </div>
                    ) : (
                      ""
                    );
                  })}
                </div>
                <div className="right-side">
                  {options.previewComponent(brandForm)}
                </div>
              </BrandingFormSection>
              <Divider marginBottom={options.marginBottom || 20}></Divider>
            </FormGroup>
          </div>
        );
      })}

      <UpgradeText className="left-pos pdd-20">
        Looking for more? Send us a suggestion.
      </UpgradeText>
      <div className="channel-forms__group">
        {edit ? (
          <Button type="submit" onClick={notify} disabled={submitting}>
            Save
          </Button>
        ) : (
          <Button type="button" onClick={() => nextTab()}>
            Save & Continue
          </Button>
        )}
      </div>
    </StyledForm>
  );
};

export default connect(
  (state) => ({
    user: state.app.user,
  }),
  null
)(BrandingForm);



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/Forms/BrandingForm.js